// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/menu.js';

import { paths } from '../generated/menu';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('menu', Original, paths);
